<template>
  <el-scrollbar>
    <label style="margin-left: 5px;font-weight: bold">员工信息:</label>
    <el-card style="margin: 5px">
      <el-form :model="employeeData" label-width="150px" disabled>
        <el-row>
          <el-col :span="12">
            <el-form-item label="工号：" required>
              <el-input v-model="employeeData.employee_no" placeholder="工号" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名：" required>
              <el-input v-model="employeeData.employee_name" placeholder="姓名" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="部门：" required>
              <el-cascader v-model="employeeData.department_ids" :options="departmentList"
                           :props="optionProps"  style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <div style="display: flex;justify-content: space-between">
      <label style="margin-left: 5px;font-weight: bold">身份信息:</label>
    </div>
    <el-card style="margin: 5px">
      <el-form :model="idCardInfo" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="24">
            <el-row>
              <el-col :span="12">
                <el-form-item label="姓名：" >
                  <el-input v-model="idCardInfo.employee_name" placeholder="姓名" clearable />
                </el-form-item>

                <el-form-item label="民族：">
                  <el-input v-model="idCardInfo.ethnicity" placeholder="民族" clearable />
                </el-form-item>
                <el-form-item label="出生日期：">
                  <el-date-picker v-model="idCardInfo.birthday" type="date"
                                  value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="性别：">
                  <el-select v-model="idCardInfo.gender" placeholder="性别" clearable>
                    <el-option label="男" value="男" />
                    <el-option label="女" value="女" />
                  </el-select>
                </el-form-item>
                <el-form-item label="公民身份证号码：">
                  <el-input v-model="idCardInfo.id_card_no" placeholder="公民身份证号码" clearable />
                </el-form-item>
                <el-form-item label="签发机关：">
                  <el-input v-model="idCardInfo.issue_authority" placeholder="签发机关" clearable />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-form-item label="住址：">
          <el-input v-model="idCardInfo.address" placeholder="住址" clearable />
        </el-form-item>

        <el-form-item label="有效期限：">
          <el-col :span="11">
            <el-date-picker v-model="idCardInfo.expire_date_start" type="date"
                            value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
          </el-col>
          <el-col :span="0.5" class="text-center">
            <span class="text-gray-500">-</span>
          </el-col>
          <el-col :span="12">
            <el-date-picker v-model="idCardInfo.expire_date_end" type="date"
                            value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
          </el-col>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="照片：">
              <span>身份证正面照片</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="">
              <span>身份证反面照片</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item>
              <kf-image-upload class="avatar-uploader" v-model="idCardInfo.man_photo_show" :init-file="employeeData.man_photo_show_obj"  @fileChange="photoChangeZ" :limit="1"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <kf-image-upload class="avatar-uploader" v-model="idCardInfo.nation_photo_show" :init-file="employeeData.nation_photo_show_obj"  @fileChange="photoChangeF" :limit="1"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-row>
      <el-col :span="24" style="text-align: center">
        <el-button type="primary" :loading="loading" @click="saveEmployeeInfo">保存</el-button>
      </el-col>
    </el-row>
  </el-scrollbar>
</template>

<script>

import {Upload} from "@element-plus/icons-vue";
import { Picture as IconPicture } from '@element-plus/icons-vue'
import { ref } from 'vue';
import axios from 'axios'

export default {
  name: "EmployeeIdCard",
  components: {Upload,IconPicture,ref},
  inject: ['$fn'],
  setup() {
    const cameraUrl = ref('http://127.0.0.1:38088/video=stream&camidx=1');

    return {
      cameraUrl,
    };
  },
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  computed: {
    boolList(){
      return this.$store.getters['core/getDictList']('bool');
    }
  },
  data() {
    return {
      optionProps: {
        emitPath:false,
        value: 'id',
        label: 'name',
        checkStrictly:true,
        multiple: true,
      },
      employeeData: {
        employee_no:'',
        employee_name:'',
        department_ids:[],
        idCardInfo:{},
      },
      dialogVisible:false,
      dialogVisibleTwo:false,
      photoType:'',
      is_custom:true,
      idCardInfo:{
      },
      departmentList: [],
      cardTypeList:[],
      loading: false,
      imageUrl: '',
      uploadObj: {
        component: 'file_upload',
        limit: 1,
      },
      uploadImgObj:{
        component: 'image_upload',
        limit: 1,
      }
    }
  },
  methods: {
    async loadEmployeeInfo() {
      let params = {id: this.parentData.employee_id}
      let dbEmployee = await this.$http('employeeInfoService.getEmployeeIdCardInfo', params);
      if(dbEmployee){
        this.employeeData = dbEmployee;
        this.idCardInfo.employee_id = dbEmployee.id;
        if(dbEmployee.idCardInfo){
          this.idCardInfo = dbEmployee.idCardInfo;
        }
      }
    },
    //获取部门列表
    async getDepartmentList() {
      this.departmentList = await this.$http('sysUserDepartmentService.getDepartmentData');
    },
    //获取证件类型
    async getCardType() {
      let params = {type: "document"}
      this.cardTypeList = await this.$http('employeeHRService.getHrConfigListByType',params);
    },
    saveEmployeeInfo(){
      if(this.idCardInfo){
        if(this.idCardInfo.id_card_no_other && this.idCardInfo.id_card_no){
          return this.$message.error("只需输入一个证件号")
        }
        if(this.idCardInfo.id_card_no){
          this.idCardInfo.card_type = "idCard";
        }else {
          this.idCardInfo.card_type = this.idCardInfo.card_type_othoer;
        }
        if(this.idCardInfo && this.idCardInfo.id_card_no){
          if(!this.idCardInfo.employee_name){
            return this.$message.error("身份证姓名不能为空")
          }
          if(this.idCardInfo.employee_name !== this.employeeData.employee_name){
            return this.$message.error("身份证姓名与员工姓名不相同")
          }
          if(this.idCardInfo.expire_date_start && this.idCardInfo.expire_date_end && this.idCardInfo.expire_date_start > this.idCardInfo.expire_date_end){
            return this.$message.error("身份证有效期结束日期不能小于开始日期");
          }
        }
      }else{
        return this.$message.error("请先上传身份证信息");
      }
      this.employeeData.idCardInfo = this.idCardInfo;
      this.loading = true;
      this.$http('employeeInfoService.editEmployeeIdCardInfo', this.employeeData, false).then(() => {
        this.$message.success("保存成功");
        this.$fn.closeWindow();
        this.$fn.search();
        this.loading = false;
      }, errMsg => {
        this.$message.error(errMsg)
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
        this.loading = false;
      })
    },
    async photoChangeZ(ids){
      if (ids.length <= 0){
        this.idCardInfo.man_photo_show = ''
        return
      }
      this.idCardInfo.man_photo_show = ids[0];
    },
    async photoChangeF(ids){
      if (ids.length <= 0){
        this.idCardInfo.nation_photo_show = ''
        return
      }
      this.idCardInfo.nation_photo_show = ids[0];
    },
    async photoChangeOtherZ(ids){
      if (ids.length <= 0){
        this.idCardInfo.man_photo_show_other = ''
        return
      }
      this.idCardInfo.man_photo_show_other = ids[0];
    },
    async photoChangeOtherF(ids){
      if (ids.length <= 0){
        this.idCardInfo.nation_photo_show_other = ''
        return
      }
      this.idCardInfo.nation_photo_show_other = ids[0];
    }
  },
  created() {
    this.getDepartmentList();
    this.loadEmployeeInfo();
    this.getCardType();
  },

}
</script>

<style lang="less">
.employee-photo{
  .el-upload-list--picture-card {
    --el-upload-list-picture-card-size: 280px;
  }
  .el-upload--picture-card{
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 280px;
    height: 320px;
  }
}


.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: var(--el-fill-color-light);
  color: var(--el-text-color-secondary);
  font-size: 30px;
}
.image-slot .el-icon {
  font-size: 30px;
}
</style>